import React from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDateComplete } from "../../../../../../utils/DateToString";
import '../../../../pages/Customers/Components/UsersList.css'

const UnderUserCorporatesList = ({UnderUsers, currentPage, setCurrentPage}) => {

  const PAGE_SIZE = 5;
  const nextPage = () => {
      if ((currentPage + 1) * PAGE_SIZE < UnderUsers.length) {
          setCurrentPage(currentPage + 1);
      }
  };
  const prevPage = () => {
      if (currentPage > 0) {
          setCurrentPage(currentPage - 1);
      }
  };
  const paginatedOrders = UnderUsers.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);
  return (
    <>

      <Table responsive="sm" className=' mx-auto text-start table-personnalisee '>
        <thead>
          <tr>
            <th>Date de création</th>
            <th>Résident</th>
            <th className="text-center">Nombre de commandes</th>
            <th className="text-center">Status</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedOrders.map((underUser, index) => {
            return (
              <tr key={index}>
                <td>{formatDateComplete(underUser.date_create?.toDate().toISOString())}</td>
                <td>{underUser.first_name} {underUser.last_name}</td>
                <td className="text-center">{underUser.nb_orders && underUser.nb_orders}</td>
                <td className="text-center">{underUser.status && underUser.status}</td>
                <td className='btn-link text-center' style={{cursor: 'pointer'}}>Voir détails</td>
                
                <td>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="d-flex flex-wrap justify-content-center my-5 bg-light py-2 rounded">
  <div className='flex-fill p-2 d-flex justify-content-center align-items-center'>{UnderUsers.length} résultats</div>
  <div className='flex-fill p-2 d-flex justify-content-center align-items-center'>
  <button onClick={prevPage} disabled={currentPage === 0} style={{border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '1.2rem'}} className="btn">Précédent</button>
                <button onClick={nextPage} className="ms-3 btn" style={{border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '1.2rem'}} disabled={(currentPage + 1) * PAGE_SIZE >= UnderUsers.length}>Suivant</button>
  </div>
            </div>
    </>
  );
};

export default UnderUserCorporatesList;